import React from 'react'

import { Field, ErrorMessage } from 'formik'
import { capitalizeFirstLetter } from 'utils/helpers'
import FieldError from './FieldError'
import { Select as ZuiSelect, SelectOption } from 'components/Zui'

export const Select = props => {
    if (props.horizontal) {
        return (
            <div className="input-wrapper-row">
                <div className="form-label-row">
                    <span>{props.label || props.name}</span>
                </div>
                <div className="input-field-wrapper">
                    <Field component={SelectComponent} {...props} />
                    <ErrorMessage name={props.name} component={FieldError} />
                </div>
            </div>
        )
    } else
        return (
            <div className="input-wrapper-column">
                <div className="form-label">
                    <span>{props.label || props.name}</span>
                </div>
                <Field component={SelectComponent} {...props} />
                <ErrorMessage name={props.name} component={FieldError} />
            </div>
        )
}

const SelectComponent = ({ field, form, children, options, ...props }) => {
    const { onBlur, onChange, ...fieldProps } = field
    // const { error } = form.getFieldMeta(field.name)

    return (
        <ZuiSelect
            {...fieldProps}
            onChange={e => {
                form.setFieldValue(field.name, e.target.value)
                form.setFieldTouched(field.name)
            }}
            {...props}
            // validationCallback={v => {
            //     return {
            //         isValid: !Boolean(error),
            //     }
            // }}
        >
            {children}
            <SelectOptionsComponent options={options} />
        </ZuiSelect>
    )
}

export const SelectOptionsComponent = ({ options }) => {
    if (Array.isArray(options)) {
        const res = options.map(option => {
            if (typeof option === 'string') {
                return (
                    <SelectOption key={option} value={option}>
                        {capitalizeFirstLetter(option)}
                    </SelectOption>
                )
            } else if (typeof option === 'object') {
                const { value, label } = option
                return (
                    <SelectOption key={value} value={value}>
                        {capitalizeFirstLetter(label || value)}
                    </SelectOption>
                )
            } else return null
        })
        return res
    }
    return null
}
